import { render, staticRenderFns } from "./ContactsInfoTable.vue?vue&type=template&id=5aa44349&scoped=true&"
import script from "./ContactsInfoTable.vue?vue&type=script&lang=js&"
export * from "./ContactsInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactsInfoTable.vue?vue&type=style&index=0&id=5aa44349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa44349",
  null
  
)

export default component.exports